import { render } from "./BotSummary.vue?vue&type=template&id=28024269"
import script from "./BotSummary.vue?vue&type=script&lang=js"
export * from "./BotSummary.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__